import React from 'react';
import { StarIcon } from 'lucide-react';
import { presets } from '../data/presets';
interface PresetBarProps {
  activeId: string | null;
  onSelect: (id: string) => void;
}
export function PresetBar({
  activeId,
  onSelect
}: PresetBarProps) {
  const recommended = presets.find(p => p.recommended);
  const others = presets.filter(p => !p.recommended);
  return <div data-id="element-90" data-mp="204wehhmn4jk1">
      <p className="text-[11px] uppercase tracking-[0.18em] text-paper-dim" data-id="element-91" data-mp="1v7mitk8nrbnr">
        Starting points
      </p>

      {recommended ? <button type="button" aria-pressed={recommended.id === activeId} onClick={() => onSelect(recommended.id)} className={['mt-3 flex w-full items-center gap-3 rounded-lg border px-4 py-3 text-left transition-colors duration-150 ease-out', recommended.id === activeId ? 'border-performance bg-ink-800' : 'border-performance/50 bg-ink-900 hover:border-performance'].join(' ')} data-id="element-92" data-mp="1q7hy1i0pvurq">
          <StarIcon className="h-4 w-4 shrink-0 text-performance" aria-hidden="true" data-id="element-93" data-mp="1wi0lqizcg7rm" />
          <span className="flex-1" data-id="element-94" data-mp="21jpzw7hv51jx">
            <span className="block text-sm font-semibold text-paper" data-id="element-95" data-mp="1nidirsqyutwg">
              {recommended.name}
            </span>
            <span className="mt-0.5 block text-xs leading-snug text-paper-dim" data-id="element-96" data-mp="1rjfj6cwmdc00">
              {recommended.tagline}
            </span>
          </span>
          {recommended.id === activeId ? <span className="text-[10px] uppercase tracking-[0.16em] text-performance" data-id="element-97" data-mp="2k960svxgmw0v">
              Active
            </span> : null}
        </button> : null}

      <div className="mt-2 flex flex-wrap gap-2" data-id="element-98" data-mp="26fez29pz0gfp">
        {others.map(preset => {
        const active = preset.id === activeId;
        return <button key={preset.id} type="button" aria-pressed={active} title={preset.tagline} onClick={() => onSelect(preset.id)} className={['whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-150 ease-out', active ? 'border-paper/60 bg-ink-800 text-paper' : 'border-line bg-ink-900 text-paper-muted hover:border-paper-dim hover:text-paper'].join(' ')} data-id="element-99" data-mp="2y7m7imvbomj0">
              {preset.name}
            </button>;
      })}
      </div>
    </div>;
}